import { render, staticRenderFns } from "./IconPicker.vue?vue&type=template&id=40f5b312"
import script from "./IconPicker.vue?vue&type=script&lang=ts"
export * from "./IconPicker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports